import React from "react";
import { Menu } from "@headlessui/react";
import { Button } from "./Button";
import { Tooltip } from "./Tooltip";
import { Plus, RefreshCw, MoreVertical, LogOut } from "lucide-react";

interface TaskPaneHeaderProps {
  onLogout?: () => void;
  onAddData?: () => void;
  onRefreshAll?: () => void;
  isRefreshingAll?: boolean;
  hasImportedCards?: boolean;
}

export function TaskPaneHeader({
  onLogout,
  onAddData,
  onRefreshAll,
  isRefreshingAll,
  hasImportedCards,
}: TaskPaneHeaderProps) {
  return (
    <div className="flex items-center gap-2 px-4 py-3 border-b border-bg3">
      <h1 className="text-base font-medium font-display-heading text-fg flex-1">
        Connected data
      </h1>

      <Tooltip label="Add data">
        <Button
          variant="tertiary"
          size="sm"
          leadingIcon={<Plus size={16} />}
          onClick={onAddData}
          aria-label="Add data"
        />
      </Tooltip>

      {hasImportedCards && (
        <Tooltip label={isRefreshingAll ? "Refreshing…" : "Refresh all"}>
          <Button
            variant="tertiary"
            size="sm"
            leadingIcon={<RefreshCw size={16} />}
            onClick={onRefreshAll}
            disabled={isRefreshingAll}
            aria-label={isRefreshingAll ? "Refreshing all" : "Refresh all"}
          />
        </Tooltip>
      )}

      <Tooltip label="More">
        <Menu as="div" className="relative flex-shrink-0">
          <Menu.Button
            as={Button}
            variant="tertiary"
            size="sm"
            leadingIcon={<MoreVertical size={16} />}
            aria-label="Menu"
          />

          <Menu.Items className="absolute right-0 mt-2 w-56 bg-bg-elevated rounded-lg shadow-lg border border-bg3 p-1 z-50 focus:outline-none">
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={onLogout}
                  className={`w-full flex items-center gap-2 px-3 py-2 text-[13px] text-fg rounded-md transition-colors ${active ? "bg-bg2" : ""}`}
                >
                  <LogOut size={16} className="text-fg2" />
                  <span>Log Out</span>
                </button>
              )}
            </Menu.Item>
          </Menu.Items>
        </Menu>
      </Tooltip>
    </div>
  );
}
